<div (click)="rout()" >
  <button class="back-button__button  ">
    <img src="assets/icons/arrow.svg" class="course-icon arrow-left" alt="arrow">
    <span class="back-button__text din-pro-condensed ">Назад</span>
  </button>
</div>
